export const SHIPPING_RATE_LOGS_ACTIONS = {
    SET_LOGS: 'SET_SHIPPING_RATE_LOGS',
    SET_LOG: 'SET_SHIPPING_RATE_LOG',
    SET_STATUS: 'SET_SHIPPING_RATE_LOGS_STATUS',
    SET_ERRORS: 'SET_SHIPPING_RATE_LOGS_ERRORS',
    CLEAR_ERRORS: 'CLEAR_SHIPPING_RATE_LOGS_ERRORS',
    SET_META: 'SET_SHIPPING_RATE_LOGS_META'
};
export const initialShippingRateLogsState = {
    status: 'idle',
    errors: [],
    data: {},
    pageCount: 0,
    rowCount: 0,
    currentPage: 1,
    perPage: 10
};
